import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { openNotification } from '../UI';
import { UpdateFirmInput } from '../generated/graphql';
import { clientUpdateFirm, useGraphqlClient } from '../graphql';
import { firmQueryKeys } from './queryKeys';

export const useUpdateFirm = () => {
  const queryClient = useQueryClient();
  const gqlClient = useGraphqlClient();
  const { t: tFirm } = useTranslation('firm');

  const updateFirm = useMutation({
    mutationFn: (input: UpdateFirmInput) => clientUpdateFirm(gqlClient, input),
    onError: () => {
      openNotification({
        type: 'error',
        description: tFirm('error-unable-to-update'),
      });
    },
    onSuccess: (_data, input) =>
      Promise.all([
        queryClient.invalidateQueries(firmQueryKeys.identifier(input.id)),
        queryClient.invalidateQueries(firmQueryKeys.firms()),
        queryClient.invalidateQueries(firmQueryKeys.branding(input.id)),
      ]),
  });

  return { updateFirm };
};
